import React from 'react'

const StatsCard = ({ title, value }) => {
    return (
        <div className='grow border-2 border-[var(--primary-30)] p-3 gap-3 rounded-xl col-span-1 shadow-md'>
            <p className="font-medium text-sm mb-0 text-[var(--secondary-text)]">{title}</p>
            <p className="text-lg font-bold mb-0">{value || 0}</p>
        </div>
    )
}

export default StatsCard